import { Component, Input } from '@angular/core';

/**
 * Read-only card for a single Financial Point, styled like the Telemetry Point
 * card (collapsible panel). Financial points are never editable here, so every
 * field is rendered disabled.
 */
@Component({
  selector: 'app-financial-point',
  templateUrl: './financial-point-details.component.html',
  styleUrls: ['./financial-point-details.component.scss', '../../shared/shared.styles.scss'],
})
export class FinancialPointDetailsComponent {
  @Input() point: any = {};
  @Input() userLocale = '';
  @Input() index = 0;
  @Input() reportingIntervals: any[] = [];
  @Input() dataProviders: any[] = [];
  @Input() channels: any[] = [];

  panelOpenedState = false;

  get displayLabel(): string {
    const labels = this.point?.displayLabels;
    if (labels && this.userLocale && labels[this.userLocale]) {
      return labels[this.userLocale];
    }
    if (labels) {
      const firstLocale = Object.keys(labels)[0];
      if (firstLocale) {
        return labels[firstLocale];
      }
    }
    return this.point?.displayLabel || this.point?.name || this.point?.id || '';
  }

  get reportingInterval(): string {
    const ms = this.point?.reportingIntervalMs;
    if (ms === undefined || ms === null) {
      return '';
    }
    const match = (this.reportingIntervals || []).find((interval: any) => interval.durationInMilliseconds == ms);
    return match ? match.displayLabel : String(ms);
  }

  get dataProvider(): string {
    const id = this.point?.dataProviderId;
    if (!id) {
      return '';
    }
    const match = (this.dataProviders || []).find((provider: any) => provider.id === id);
    return match ? match.displayLabel : id;
  }

  get channel(): string {
    const id = this.point?.channelId;
    if (id === undefined || id === null) {
      return '';
    }
    const match = (this.channels || []).find((channel: any) => channel.id == id);
    return match ? match.displayLabel : String(id);
  }
}
